import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import DealerLocatorSubApp from '@honda-canada/react-subapp-dealer-locator/lib/components/DealerLocator';
import { useTranslation } from 'react-i18next';
import DealerLocatorUI from './DealerLocatorUI';
import useCheckVehicleType from './hooks/useCheckVehicleType';
import { useAppName } from '../../utils/sitecoreContext';
import { HONDA_SITE_NAME } from '../../utils/constants';
import { useAppSelector } from '../../core/utils';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import usePageTitle from '../../utils/hooks/usePageTitle';
import { selectModelNameByModelKey } from '../../core/reducers/vehicles';
const DealerLocator = ({ fields, params, rendering }) => {
    var _a, _b, _c, _d, _e, _f;
    const appName = useAppName();
    const { t } = useTranslation();
    const variant = params === null || params === void 0 ? void 0 : params.variant;
    const sitecoreModels = (_f = (_e = (_d = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.catalog) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.models) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.items;
    const componentName = rendering === null || rendering === void 0 ? void 0 : rendering.componentName;
    const { modelKey, modelYear } = useAppSelector(selectCurrentVehicle);
    const queryString = new URLSearchParams({ modelKey, modelYear }).toString();
    const { isVehicleEV } = useCheckVehicleType(sitecoreModels, modelYear, modelKey);
    const INVENTORY_VARIANT = 'variant2';
    const isInventoryVariant = variant === INVENTORY_VARIANT;
    const modelName = useAppSelector(selectModelNameByModelKey);
    const pageTitle = usePageTitle(modelName, isInventoryVariant);
    let showEvAlertMsg;
    switch (appName) {
        case HONDA_SITE_NAME:
            showEvAlertMsg = true;
            break;
        default:
            showEvAlertMsg = false;
            break;
    }
    const alertMessage = isVehicleEV && showEvAlertMsg ? t('Sub-apps.Dealers.evAlertText', { modelYear, modelName }) : '';
    switch (variant) {
        case INVENTORY_VARIANT:
            return (_jsx(DealerLocatorUI, { fields: fields, componentName: componentName, alertMessage: alertMessage, isVehicleEV: isVehicleEV, ctaQueryString: queryString, pageTitle: pageTitle }));
        default:
            return _jsx(DealerLocatorSubApp, {});
    }
};
export default DealerLocator;
